export default function getResource(label) {
    const resources = {
        awarenessTitle: 'The three 100-point rewards for 250 points perk is only available for shipped orders.',
        infoIconLabel: 'Reward bundling terms and conditions'
    };

    return resources[label];
}
